import React, {useRef, useEffect, useLayoutEffect, useState} from 'react';
let sdnn = 0
let rmssd = 0
let pnn20 = 0
let pnn50 = 0

const CanvasGridDashboard = ({ points, setPulsUser=(value)=>{}, singleChart = false, xMode = 'index', hidePagination = false, chartKey = '', xUnitsPerSecond = 250 }) => {
    const canvasRef = useRef(null);
    const canvasRefPhoto = useRef(null);
    const canvasRefAccel = useRef(null);
    const requestRef = useRef(null);
    const previousPointRef = useRef(0);
    const pointIdRef = useRef(0);
    const isFirstR =  useRef(false);
    const isFirstRX =  useRef(0);
    const pointPhotoIdRef = useRef({x:0, y:0, isRPeaks:false});
    const pointAccelXIdRef = useRef({x:0, y:0, isRPeaks:false});
    const pointAccelYIdRef = useRef({x:0, y:0, isRPeaks:false});
    const pointAccelZIdRef = useRef({x:0, y:0, isRPeaks:false});
    const startRef = useRef();
    const [animationPoints, setAnimationPoints] = useState([]);
    const [pulsSet, setPulsSet] = useState([]);
    const containerRef = useRef(null);
    let xMoveDif = useRef(0);
    let xLineDif = useRef(0);

    const [showMainCanvas, setShowMainCanvas] = useState(true);
    const [showPhotoCanvas, setShowPhotoCanvas] = useState(!singleChart);
    const [showAccelCanvas, setShowAccelCanvas] = useState(!singleChart);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10000; // 10000 единиц оси X = 40 c при 250 ед/с
    const maxX = points.length
        ? Math.max(...points.map((p) => p.x))
        : 0;
    const totalPages = Math.max(
        1,
        xMode === 'time'
            ? Math.ceil((maxX + 1) / itemsPerPage)
            : Math.ceil(points.length / itemsPerPage),
    );

    const pixelsPerSecond = useRef(250);
    const staticChart = singleChart && xMode === 'time';

    const lastTime = useRef(0);
    const difTime = useRef(0);
    const timeStep = useRef(1);

    const drawAllGrids = () => {
        if (staticChart) {
            const chartPoints = getStaticChartPoints();
            if (chartPoints.length) {
                drawStaticChart(chartPoints);
            }
            return;
        }
        drawGrid();
        if (!singleChart) {
            drawGrid(canvasRefPhoto.current);
            drawGrid(canvasRefAccel.current);
        }
        drawTimeScale();
    };

    const getStaticChartPoints = () => (hidePagination ? points : animationPoints);

    useEffect(() => {
        const onResize = () => {
            if (staticChart) {
                const chartPoints = getStaticChartPoints();
                if (chartPoints.length) drawStaticChart(chartPoints);
            } else {
                drawGrid();
                if (!singleChart) {
                    drawGrid(canvasRefPhoto.current);
                    drawGrid(canvasRefAccel.current);
                }
                drawTimeScale();
            }
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [staticChart, hidePagination, points, chartKey]);

    const drawGrid = (can = canvasRef.current, forcedWidth = null) => {
        if (!can) return;
        const canvas = can;
        const ctx = canvas.getContext('2d');
        if (forcedWidth != null) {
            canvas.style.width = `${forcedWidth}px`;
            canvas.style.maxWidth = '100%';
            canvas.style.display = 'block';
            canvas.width = forcedWidth;
        } else if (containerRef.current) {
            canvas.style.width = '';
            canvas.style.maxWidth = '';
            canvas.width = containerRef.current.scrollWidth;
        }
        const width = canvas.width;
        canvas.height = 250;
        const originalHeight = 500;

        const scale = 0.5;
       // canvas.width = originalWidth * scale;
        //canvas.height = originalHeight * scale;
        //ctx.scale(scale, scale);
        const height = canvas.height;

        // Очистка canvas
        ctx.clearRect(0, 0, width, height);
        ctx.fillStyle = '#0c0e12'
        ctx.fillRect(0, 0, width, height);
        //#13161B
        // Настройки для сетки

        ctx.lineWidth = 0.2;
        ctx.fillStyle = '#13161B';

        // Рисуем точки с шагом 10 пикселей
        for (let x = 15; x < width; x += 15) {
            for (let y = 15; y < height; y += 15) {
                ctx.fillRect(x, y, 2, 2); // Рисуем точку размером 1x1 пиксель
            }
        }

        ctx.strokeStyle = '#ea0606';


        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 1;

        for (let x = 40; x < width; x += 80) {
            ctx.beginPath();
            ctx.moveTo(x, height);
            ctx.lineTo(x, height - 7);
            ctx.stroke();
        }
        for (let x = 0; x < width; x += 80) {
            ctx.beginPath();
            ctx.moveTo(x, height);
            ctx.lineTo(x, height - 12);
            ctx.stroke();
        }

        ctx.beginPath();
        ctx.moveTo(0, height-1);
        ctx.lineTo(width, height-1);
        ctx.stroke();
    };
    const drawTimeScale = (added = false) => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const width = canvas.width;
        const height = canvas.height;
        //console.log(added)
        ctx.fillStyle = '#fff';
        ctx.font = '12px Arial';

        // Отрисовка временной шкалы
        if(!added) {
            lastTime.current = 0
            difTime.current = 0
        }
        for (var t = lastTime.current; t <= lastTime.current + (width / pixelsPerSecond.current)-difTime.current; t += timeStep.current) {
            const x = (t - lastTime.current) * pixelsPerSecond.current
            //ctx.fillText(t.toFixed(1) + 's', x+difTime.current* pixelsPerSecond.current, height - 15)

        }
        if(t>(width / pixelsPerSecond.current)) {
            difTime.current = difTime.current+((t - lastTime.current) - (width / pixelsPerSecond.current))
        }
        lastTime.current = t

    }

    const drawStaticTimeLabels = (chartWidth, pagePoints, pageStartSec = 0, mapX = (x) => x) => {
        const canvas = canvasRef.current;
        if (!canvas || !pagePoints.length) return;
        const ctx = canvas.getContext('2d');
        const height = canvas.height;
        const maxPageX = Math.max(...pagePoints.map((p) => p.x));

        ctx.fillStyle = '#fff';
        ctx.font = '12px Arial';
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 1;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';

        const totalSec = maxPageX / Math.max(xUnitsPerSecond, 1);
        const maxTicks = Math.max(2, Math.floor(chartWidth / 72));
        const raw = totalSec / maxTicks;
        const nice = [1, 2, 5, 10, 15, 20, 30, 60, 120, 300, 600];
        const stepSec = nice.find((s) => s >= raw) || Math.ceil(raw / 60) * 60;

        for (let sec = 0; sec <= totalSec + 1e-6; sec += stepSec) {
            const px = mapX(sec * xUnitsPerSecond);
            ctx.fillText(`${Math.round(sec)}s`, px, height - 16);
            ctx.beginPath();
            ctx.moveTo(px, height);
            ctx.lineTo(px, height - 10);
            ctx.stroke();
        }
    };

    const drawStaticChart = (pagePoints) => {
        const canvas = canvasRef.current;
        if (!canvas || !containerRef.current || !pagePoints.length) {
            drawAllGrids();
            return;
        }

        if (containerRef.current) {
            containerRef.current.scrollLeft = 0;
        }

        const containerWidth = Math.max(1, Math.floor(containerRef.current.clientWidth || 1));
        const xs = pagePoints.map((p) => p.x);
        const minX = Math.min(...xs);
        const maxX = Math.max(...xs);
        const chartWidth = containerWidth;
        const xSpan = maxX - minX || 1;
        const mapX = (x) => ((x - minX) / xSpan) * Math.max(chartWidth - 8, 1);

        drawGrid(canvas, chartWidth);
        const ctx = canvas.getContext('2d');
        const height = canvas.height;
        const ys = pagePoints.map((p) => p.y);
        let minY = Math.min(...ys);
        let maxY = Math.max(...ys);
        if (maxY === minY) {
            minY = Math.min(0, minY);
            maxY = maxY === 0 ? 1 : maxY;
        }
        const yRange = Math.max(maxY - minY, 1);
        const plotTop = 20;
        const plotBottom = height - 25;
        const mapY = (y) => plotBottom - ((y - minY) / yRange) * (plotBottom - plotTop);

        ctx.strokeStyle = 'blue';
        ctx.lineWidth = 2;
        ctx.beginPath();
        pagePoints.forEach((point, idx) => {
            const px = mapX(point.x);
            const py = mapY(point.y);
            if (idx === 0) ctx.moveTo(px, py);
            else ctx.lineTo(px, py);
        });
        ctx.stroke();

        drawStaticTimeLabels(chartWidth, pagePoints, 0, mapX);
    };

    const animate =(timestamp)=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const canvasPhoto = singleChart ? null : canvasRefPhoto.current;
        const canvasAccel = singleChart ? null : canvasRefAccel.current;
        const height = canvas.height;
        const ctx = canvas.getContext('2d');
        const ctxPhoto = canvasPhoto ? canvasPhoto.getContext('2d') : null;
        const ctxAccel = canvasAccel ? canvasAccel.getContext('2d') : null;
        ctx.strokeStyle = 'blue';
        ctx.lineWidth = 3;


        if (!startRef.current) {
            startRef.current = timestamp;
        }
        if(pointIdRef.current===0 ) {
            drawGrid();
            if (!singleChart) {
                drawGrid(canvasRefPhoto.current);
                drawGrid(canvasRefAccel.current);
            }
            drawTimeScale(true)
        }
        if(previousPointRef.current && timestamp-startRef.current>100){
            if(previousPointRef.current<timestamp){
                let i =1

                while(i<50000) {

                    if (!animationPoints[pointIdRef.current]) {
                        return () => cancelAnimationFrame(requestRef.current);
                    }
                    const pageXOffset = xMode === 'index' ? itemsPerPage * currentPage : 0;
                    let xMove = animationPoints[Math.max(pointIdRef.current - 1, 0)].x - pageXOffset;
                    let xLine = animationPoints[pointIdRef.current].x - pageXOffset;

                    const scrollWidth = containerRef.current?.scrollWidth || canvas.width;
                    if (
                        xLine > 0 &&
                        Math.floor(xLine / scrollWidth) > Math.floor(xMoveDif.current / scrollWidth)
                    ) {
                        xMoveDif.current = Math.floor(xLine / scrollWidth) * scrollWidth;
                        xLineDif.current = xMoveDif.current;
                        drawGrid();
                        if (!singleChart) {
                            drawGrid(canvasRefPhoto.current);
                            drawGrid(canvasRefAccel.current);
                        }
                        drawTimeScale(true);
                    }

                        ctx.strokeStyle = 'blue';
                        ctx.beginPath();
                        ctx.moveTo(xMove - Number(xMoveDif.current), canvas.height - animationPoints[Math.max(pointIdRef.current - 1, 0)].y/2);
                        ctx.lineTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y/2);
                        if(animationPoints[pointIdRef.current].marker && animationPoints[pointIdRef.current].marker==='R'){
                            if(!isFirstR.current) {
                                isFirstR.current = true
                                isFirstRX.current = xMove - Number(xMoveDif.current)
                            }else{

                                //setPulsUser((60/(((xMove - Number(xMoveDif.current))-isFirstRX.current)/250 )).toFixed(0))
                                const puls = Number((60/(((xMove - Number(xMoveDif.current))-isFirstRX.current)/250 )).toFixed(0))
                                setPulsSet(prev => {
                                    const array = [...prev, puls]
                                    if(array.length>4){
                                        const lastFive = array.slice(-5); // Получаем последние 5 элементов
                                        const average = lastFive.reduce((sum, val) => {
                                            return sum + val
                                        }, 0) / 5;
                                        setPulsUser(average.toFixed(0))
                                    }
                                    return array; // Создаем новый массив с добавленным элементом
                                });
                                isFirstRX.current = xMove - Number(xMoveDif.current)

                            }
                            ctx.fillStyle = "#ffffff";
                        }
                        if(animationPoints[pointIdRef.current].marker) {
                            ctx.fillStyle = "#ffffff";
                            const textX = 20;
                            const textY = canvas.height - canvas.height / 2 + 50;
                            const textWidth = ctx.measureText("SDNN: " + 1).width;

                            const textHeight = 20;

                            ctx.clearRect(textX, textY - textHeight, textWidth+100, textHeight*4);
                            ctx.fillText("SDNN:", 20, canvas.height - canvas.height/2+50)
                            ctx.fillText("RMSSD:", 20, canvas.height - canvas.height/2+70)
                            ctx.fillText("PNN20:", 20, canvas.height - canvas.height/2+90)
                            ctx.fillText("PNN50:", 20, canvas.height - canvas.height/2+110)

                           // ctx.fillText(animationPoints[pointIdRef.current].marker, xMove - Number(xMoveDif.current), canvas.height - animationPoints[pointIdRef.current].y)

                            ctx.fillStyle = "#17B26A";

                            ctx.fillText(animationPoints[pointIdRef.current].sdnn.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+50)
                            ctx.fillText(animationPoints[pointIdRef.current].rmssd.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+70)
                            ctx.fillText(animationPoints[pointIdRef.current].pnn20.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+90)
                            ctx.fillText(animationPoints[pointIdRef.current].pnn50.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+110)
                            sdnn = animationPoints[pointIdRef.current].sdnn.toFixed(2)
                            rmssd = animationPoints[pointIdRef.current].rmssd.toFixed(2)
                            pnn20 = animationPoints[pointIdRef.current].pnn20.toFixed(2)
                            pnn50 = animationPoints[pointIdRef.current].pnn50.toFixed(2)
                        }
                        const globalX = xMode === 'time'
                            ? xLine + currentPage * itemsPerPage
                            : pointIdRef.current + itemsPerPage * currentPage;
                        const prevGlobalX = xMode === 'time'
                            ? xMove + currentPage * itemsPerPage
                            : Math.max(pointIdRef.current - 1, 0) + itemsPerPage * currentPage;
                        if (Math.floor(globalX / 250) > Math.floor(prevGlobalX / 250)) {
                            ctx.fillStyle = "#ffffff";
                            const labelPos = (xMode === 'time' ? xLine : pointIdRef.current) - Number(xMoveDif.current);
                            const labelText = Math.floor(globalX / 250) + 's';
                            ctx.fillText(labelText, labelPos, height - 15);
                            if (!singleChart && ctxPhoto && ctxAccel) {
                                ctxPhoto.fillStyle = "#ffffff";
                                ctxAccel.fillStyle = "#ffffff";
                                ctxPhoto.fillText(labelText, labelPos, height - 15);
                                ctxAccel.fillText(labelText, labelPos, height - 15);
                            }
                        }
                    if (!singleChart && ctxPhoto && ctxAccel) {
                    ctxPhoto.stroke();
                    ctxPhoto.strokeStyle = 'red';
                    ctxPhoto.beginPath();
                    if(xLine ===0){
                        //ctx.moveTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y1);
                        pointPhotoIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].y1, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}
                    }
                    if (animationPoints[pointIdRef.current].y1 && xLine!==0) {
                        ctxPhoto.moveTo(pointPhotoIdRef.current.x - Number(xMoveDif.current), canvas.height - pointPhotoIdRef.current.y/2);
                        ctxPhoto.lineTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y1/2);
                        pointPhotoIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].y1, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}

                    }
                    ctxAccel.stroke();
                    ctxAccel.strokeStyle = 'red';
                    ctxAccel.beginPath();
                    if(xLine ===0){
                        //ctx.moveTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y1);
                        pointAccelXIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].accelX, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}
                    }
                    if (animationPoints[pointIdRef.current].accelX && xLine!==0) {

                        ctxAccel.moveTo(pointAccelXIdRef.current.x - Number(xMoveDif.current), canvas.height - pointAccelXIdRef.current.y/2);
                        ctxAccel.lineTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].accelX/2);
                        pointAccelXIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].accelX, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}

                    }
                    ctxAccel.stroke();
                    ctxAccel.strokeStyle = 'green';
                    ctxAccel.beginPath();
                    if(xLine ===0){
                        //ctx.moveTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y1);
                        pointAccelYIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].accelY, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}
                    }
                    if (animationPoints[pointIdRef.current].accelY && xLine!==0) {

                        ctxAccel.moveTo(pointAccelYIdRef.current.x - Number(xMoveDif.current), canvas.height - pointAccelYIdRef.current.y/2);
                        ctxAccel.lineTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].accelY/2);
                        pointAccelYIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].accelY, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}

                    }
                    ctxAccel.stroke();
                    ctxAccel.strokeStyle = 'blue';
                    ctxAccel.beginPath();
                    if(xLine ===0){
                        //ctx.moveTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y1);
                        pointAccelZIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].accelZ, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}
                    }
                    if (animationPoints[pointIdRef.current].accelY && xLine!==0) {

                        ctxAccel.moveTo(pointAccelZIdRef.current.x - Number(xMoveDif.current), canvas.height - pointAccelZIdRef.current.y/2);
                        ctxAccel.lineTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].accelZ/2);
                        pointAccelZIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].accelZ, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}

                    }
                    //ctx.fillText(t.toFixed(1) + 's', x+difTime.current* pixelsPerSecond.current, height - 15)
                    }
                    ctx.stroke();
                    if (!singleChart && ctxPhoto && ctxAccel) {
                        ctxPhoto.stroke();
                        ctxAccel.stroke();
                    }
                    pointIdRef.current = pointIdRef.current+1
                    i++

                }

            }
        }
        previousPointRef.current = timestamp

        requestRef.current = requestAnimationFrame(animate);

    }

    useEffect(()=>{
        if (staticChart) return undefined;
        startRef.current = 0
        requestRef.current = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(requestRef.current);
    },[animationPoints, staticChart])

    useLayoutEffect(() => {
        if (!staticChart || !hidePagination) return;
        const chartPoints = getStaticChartPoints();
        if (!chartPoints.length || (chartPoints.length === 1 && chartPoints[0].x === 0 && chartPoints[0].y === 0)) {
            drawAllGrids();
            return;
        }
        drawStaticChart(chartPoints);
    }, [staticChart, hidePagination, points, chartKey]);

    useEffect(() => {
        if (staticChart && hidePagination) return;
        if (!staticChart) {
            drawAllGrids();
        }
    }, [staticChart, hidePagination]);

    const updateVisiblePoints = (page, sourcePoints) => {
        let pagePoints;
        if (xMode === 'time') {
            const startX = page * itemsPerPage;
            const endX = startX + itemsPerPage;
            pagePoints = sourcePoints
                .filter((p) => p.x >= startX && p.x < endX)
                .map((p) => ({ ...p, x: p.x - startX }));
        } else {
            const startIndex = page * itemsPerPage;
            const endIndex = Math.min(startIndex + itemsPerPage, sourcePoints.length);
            pagePoints = sourcePoints.slice(startIndex, endIndex);
        }
        pointIdRef.current = 0;
        previousPointRef.current = 0;
        xMoveDif.current = 0;
        xLineDif.current = 0;
        setAnimationPoints(pagePoints);
        if (staticChart) {
            drawStaticChart(pagePoints);
        } else {
            drawAllGrids();
        }
    };
    useEffect(()=>{
        if (staticChart && hidePagination) return;
        updateVisiblePoints(currentPage, points)
    },[currentPage, staticChart, hidePagination, points])
    useEffect(() => {
        if (staticChart && hidePagination) return;
        if(points.length===0){
            pointIdRef.current = 0
            drawAllGrids();
        }
        pointIdRef.current = 0
        setCurrentPage(0)
        updateVisiblePoints(0, points)
    }, [points, staticChart, hidePagination]);

    const handlePrev = () => {
        setCurrentPage(prev => Math.max(prev - 1, 0));
    };

    const handleNext = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages - 1));
    };
    return (
        <div
            ref={containerRef}

            style={{backgroundColor:'#0c0e12',
                textAlign: 'left',
                width: '100%',
                overflowX: staticChart ? 'hidden' : 'overlay'
            }}

        >
            {!singleChart && (
            <canvas
            ref={canvasRefAccel}
            width={animationPoints.length}
            height={250}
            style={{ display: showAccelCanvas ? 'block' : 'none' }}
            />
            )}

            {!singleChart && (
            <canvas
                ref={canvasRefPhoto}
                width={animationPoints.length}
                height={250}
                style={{ display: showPhotoCanvas ? 'block' : 'none' }}
            />
            )}
            <canvas
                ref={canvasRef}
                {...(!staticChart ? { width: animationPoints.length } : {})}
                height={250}
                style={{
                    display: showMainCanvas ? 'block' : 'none',
                    ...(staticChart ? { width: '100%', maxWidth: '100%' } : {}),
                }}
            />
            {!hidePagination && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                <button
                    onClick={handlePrev}
                    disabled={currentPage === 0}
                    style={{ margin: '0 5px', padding: '5px 10px' }}
                >
                    Previous
                </button>
                <span style={{ margin: '0 10px', color: 'white' }}>
                  Page {currentPage + 1} of {totalPages}
                </span>
                <button
                    onClick={handleNext}
                    disabled={currentPage === totalPages - 1}
                    style={{ margin: '0 5px', padding: '5px 10px' }}
                >
                    Next
                </button>
            </div>
            )}
            {!singleChart && (
            <div style={{ display: 'flex', gap: '15px', marginBottom: '10px', color: 'white' }}>
                <label>
                    <input
                        type="checkbox"
                        checked={showMainCanvas}
                        onChange={() => setShowMainCanvas(!showMainCanvas)}
                    />
                    ECG Graph
                </label>
                <label>
                    <input
                        type="checkbox"
                        checked={showPhotoCanvas}
                        onChange={() => setShowPhotoCanvas(!showPhotoCanvas)}
                    />
                    PPG Graph
                </label>
                <label>
                    <input
                        type="checkbox"
                        checked={showAccelCanvas}
                        onChange={() => setShowAccelCanvas(!showAccelCanvas)}
                    />
                    Acceleration Graph
                </label>
            </div>
            )}

        </div>
    )

}

export default CanvasGridDashboard
